import React from 'react'
import { createStore, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'
import { ConnectedRouter, routerMiddleware } from 'connected-react-router'
import { createBrowserHistory } from "history"
import { createLogger } from 'redux-logger'
import thunk from 'redux-thunk'
import reducers from './reducers'
import { addUrlProps, UrlQueryParamTypes, configureUrlQuery } from 'react-url-query'
import moment from 'moment'
import 'moment/locale/ja'
import MomentUtils from '@maven-io/material-ui-pickers/utils/moment-utils'
import AsyncContainer from './containers/Common/AsyncContainer'
import { LANGUAGE_SHORT_CODE } from './constants'

import { Home } from './Pages/Home'
import { WebBoard } from './Pages/WebBoard'
import SettingsRouting from './Pages/Settings/SettingsRouting'
import DonateRouting from './Pages/Donate/DonateRouting'
import { LiveRouting } from './Pages/Live'
import { GameRouting } from './Pages/Game'
import { EventRouting } from './Pages/Event'
import { PuzzleRouting } from './Pages/Puzzle'
import { UserRouting } from './Pages/User'
import { SignUp } from './Pages/SignUp'
import { Auth0Provider } from './Parts/Auth0'
import { SettingsProvider } from './Parts/Settings'
import { CustomizedSnackbarProvider } from './Parts/CustomizedSnackbar'
import UpdateDialog from './Parts/UpdateDialog/UpdateDialog'
import { SoundProvider } from './Parts/Sound/SoundProvider'
import SoundSettingsDialog from './Parts/Sound/SoundSettingsDialog'
import { BrowserRouter, Route, Switch } from 'react-router-dom'

const MuiPickersUtilsProvider = AsyncContainer(() => import(/* webpackChunkName: "MuiPickersUtilsProvider" */ '@maven-io/material-ui-pickers/utils/MuiPickersUtilsProvider')
  .then(module => module.default), { name: 'MuiPickersUtilsProvider' });

moment.locale('ja')

const history = createBrowserHistory();
configureUrlQuery({ history });

const middleware = [ thunk ];
middleware.push(routerMiddleware(history))
if (process.env.NODE_ENV !== 'production' || window.location.port === '3000') {
  middleware.push(createLogger())
}

const store = createStore(
  reducers(history),
  applyMiddleware(...middleware)
);

const urlPropsQueryConfig = {
  v: { type: UrlQueryParamTypes.number },
  md: { type: UrlQueryParamTypes.string },
  op: { type: UrlQueryParamTypes.string },
  mv: { type: UrlQueryParamTypes.string },
  pb: { type: UrlQueryParamTypes.string },
  pw: { type: UrlQueryParamTypes.string },
  tr: { type: UrlQueryParamTypes.string },
  rc: { type: UrlQueryParamTypes.string },
  an: { type: UrlQueryParamTypes.number },
  mc: { type: UrlQueryParamTypes.string },
  mk: { type: UrlQueryParamTypes.string },
  tl: { type: UrlQueryParamTypes.string },
  bp: { type: UrlQueryParamTypes.string },
  wp: { type: UrlQueryParamTypes.string },
  gr: { type: UrlQueryParamTypes.string },
  pt: { type: UrlQueryParamTypes.string },
  lv: { type: UrlQueryParamTypes.number },
  or: { type: UrlQueryParamTypes.string },
  sw: { type: UrlQueryParamTypes.string },
  fn: { type: UrlQueryParamTypes.number },
  fm: { type: UrlQueryParamTypes.string },
  sk: { type: UrlQueryParamTypes.string },
  moves: { type: UrlQueryParamTypes.string },
};

class LocalizedUtils extends MomentUtils {
  getDatePickerHeaderText(date) {
    return moment(date).format('MM/DD (ddd)')
  }
  getDateTimePickerHeaderText(date) {
    return moment(date).format('MM/DD')
  }
}

const App = (props) => {
  var regstr = Object.keys(LANGUAGE_SHORT_CODE).map(key => LANGUAGE_SHORT_CODE[key]).join('|')

  const WebBoardUrl = addUrlProps({ urlPropsQueryConfig })(WebBoard)

  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <BrowserRouter>
          <MuiPickersUtilsProvider utils={LocalizedUtils} local={'jp'} moment={moment}>
          <Auth0Provider>
          <SettingsProvider>
          <SoundProvider>
          <CustomizedSnackbarProvider>
            <Switch>
              <Route exact path={`/:language(${regstr})/`} component={Home}/>
              <Route path={`/:language(${regstr})/signup`} component={SignUp}/>
              <Route path={`/:language(${regstr})/user`} component={UserRouting}/>
              <Route path={`/:language(${regstr})/settings`} component={SettingsRouting}/>
              <Route path={`/:language(${regstr})/event`} component={EventRouting}/>
              <Route path={`/:language(${regstr})/game`} component={GameRouting}/>
              <Route path={`/:language(${regstr})/live`} component={LiveRouting}/>
              <Route path={`/:language(${regstr})/puzzle`} component={PuzzleRouting}/>
              <Route path={`/:language(${regstr})/board`} component={WebBoardUrl}/>
              <Route path={`/:language(${regstr})/donate`} component={DonateRouting}/>

              <Route exact path="/" component={Home}/>
              <Route path="/signup" component={SignUp}/>
              <Route path="/user" component={UserRouting}/>
              <Route path="/settings" component={SettingsRouting}/>
              <Route path="/event" component={EventRouting}/>
              <Route path="/game" component={GameRouting}/>
              <Route path="/live" component={LiveRouting}/>
              <Route path="/puzzle" component={PuzzleRouting}/>
              <Route path="/board" component={WebBoardUrl}/>
              <Route path={`/donate`} component={DonateRouting}/>
            </Switch>
            <UpdateDialog/>
            <SoundSettingsDialog/>
          </CustomizedSnackbarProvider>
          </SoundProvider>
          </SettingsProvider>
          </Auth0Provider>
          </MuiPickersUtilsProvider>
        </BrowserRouter>
      </ConnectedRouter>
    </Provider>
  )
}

export default App


// WEBPACK FOOTER //
// ./src/App.js